module.exports = __webpack_public_path__ + "static/Spinturnix.com-Social-864a21ebca7a8fe9894c104f3c856582.jpg";